import * as React from 'react';

const TableFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M4 7v10h16V7H4z" />
        <g fillRule="evenodd" clipRule="evenodd">
            <circle cx={6} cy={4} r={2} />
            <circle cx={12} cy={4} r={2} />
            <circle cx={18} cy={4} r={2} />
            <circle cx={6} cy={20} r={2} />
            <circle cx={12} cy={20} r={2} />
            <circle cx={18} cy={20} r={2} />
        </g>
    </svg>
);

TableFillSvg.displayName = 'TableFillSvg';
export default TableFillSvg;
